import { ArrowRight } from 'lucide-react';
import { buttonVariants } from './ui/Button';
import { useT } from '@/i18n/provider';

export function CTASection() {
  const t = useT();

  return (
    <section className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="animate-on-scroll relative rounded-3xl gradient-primary overflow-hidden px-8 py-16 sm:px-16 sm:py-20 text-center">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/3" />

          <div className="relative">
            <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight text-balance">
              {t('cta.title')}
            </h2>
            <p className="mt-4 text-lg text-white/80 max-w-xl mx-auto">
              {t('cta.subtitle')}
            </p>
            <div className="mt-8">
              <a href="https://app.logpulse.io/sign-in" className={buttonVariants({ variant: 'outline-white', size: '2xl' })}>
                {t('cta.button')}
                <ArrowRight className="h-5 w-5 ml-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
